import React, { useState, useEffect } from "react";
import "../Favorites/Favorites.css";
import axios from "axios";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { Link, useNavigate } from "react-router-dom";
import emptyFav from "../../assets/empty-cart.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import placeholder from "../../assets/placeholder.jpg";

export default function Favorites() {
  const [favoritesProducts, setFavoritesProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setFavoritesProducts([]);
          return;
        }

        const res = await axios.get(
          `${BaseUrl}${BuyerServicesUrl.GetProductsFavoriteList}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        setFavoritesProducts(res.data?.data?.data || []);
      } catch (err) {
        console.error(err);
        toast.error("حدث خطأ أثناء تحميل المفضلة");
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, []);

  // ===== add to cart=====
  const addToCart = async (productId) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        toast.warning("يرجى تسجيل الدخول أولاً");
        return;
      }

      await axios.post(
        BaseUrl + BuyerServicesUrl.AddToCart,
        { product_id: productId, quantity: 1 },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      window.dispatchEvent(new Event("cartUpdated"));
      toast.success("تم إضافة المنتج للعربة بنجاح");
    } catch (err) {
      const apiMessage =
        err.response?.data?.data || err.response?.data?.message || "";
      const message = apiMessage.toLowerCase().trim();

      if (message.includes("same seller")) {
        toast.error("لا يمكن إضافة منتجات من بائعين مختلفين في نفس السلة");
      } else if (message.includes("stock") || message.includes("out of stock")) {
        toast.error("المنتج غير متوفر حالياً");
      } else if (message.includes("unauthorized")) {
        toast.error("يرجى تسجيل الدخول أولاً");
      } else {
        toast.error("حدث خطأ أثناء الإضافة للعربة");
      }

      console.error(err);
    }
  };

  const toggleFavorite = async (e, productId) => {
    e.stopPropagation();

    const token = localStorage.getItem("token");
    if (!token) {
      toast.warning("يرجى تسجيل الدخول أولاً");
      return;
    }

    // optimistic remove
    const backup = favoritesProducts;
    setFavoritesProducts((prev) => prev.filter((p) => p.id !== productId));

    try {
      await axios.get(
        BaseUrl +
          BuyerServicesUrl.AddProductToFavorites.replace("{id}", productId),
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast("تمت الإزالة من المفضلة", {
        style: { background: "#ff7100", color: "#fff" },
      });
    } catch (err) {
      setFavoritesProducts(backup);
      toast.error("حدث خطأ أثناء تحديث المفضلة ❌");
      console.error(err);
    }
  };

  return (
    <>
    
      <div className="fav-page mt-3 mb-5 pt-5 pb-5">
        <div className="container mt-5 pt-4 mb-5">
          {loading ? (
            <div className="favorites-loader text-center py-5 "      style={{
        minHeight: "75vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginBottom:"160px"
      }}
    >
              <div className="loader-circle mb-3"></div>
              <p className="fw-bold">جاري تحميل المفضلة...</p>
            </div>
          ) : favoritesProducts.length === 0 ? (
            <div className="empty-favorites text-center py-5">
              <img
                src={emptyFav}
                alt="no favorites"
                className="empty-img mb-4"
              />
              <h4 className="fw-bold">لا يوجد منتجات في المفضلة</h4>
              <p className="text-muted mt-2">
                يمكنك إضافة منتجات إلى المفضلة لتظهر هنا
              </p>

              <Link to="/" className="favproducts text-white pt-2 pb-2 mt-3">
                تصفح المنتجات
              </Link>
            </div>
          ) : (
            <>
              <div className="fav-header d-flex justify-content-between align-items-center mb-3">
                {/* <h4 className="fw-bold mb-0">
                  المنتجات ({favoritesProducts.length})
                </h4> */}
              </div>

              <div className="row">
                {favoritesProducts.map((item) => (
                  <div className="col-md-3 col-sm-6 mb-4" key={item.id}>
                    <div className="product-card">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(`/advertisementdetails/${item.id}`)}
                      >
                        <div className="fav-img-wrap">
                          {/*  */}
                          <div
                            className="fav-btn active"
                            onClick={(e) => toggleFavorite(e, item.id)}
                            title="إزالة من المفضلة"
                          >
                            ❤
                          </div>

                          <img
                            src={item.image?.[0] || placeholder}
                            alt={item.name}
                            className="fav-img"
                            onError={(e) => {
                              e.target.src = placeholder;
                            }}
                          />
                        </div>

                        <h6 className="mt-3 fw-bold pt-1">{item.name}</h6>

                        <p className="product-desc pb-1">
                          {(item.description || "")
                            .split(" ")
                            .slice(0, 4)
                            .join(" ")}
                          ...
                        </p>

                        <p className="price pb-2">
                          {(item.priceAfterDiscount > 0
                            ? item.priceAfterDiscount
                            : item.price) || item.price}{" "}
                          {item.currency_type}
                        </p>
                      </div>

                      <button
                        className="addcart text-white border-0 pt-2 pb-2 mb-3"
                        onClick={(e) => {
                          e.stopPropagation();
                          addToCart(item.id);
                        }}
                      >
                        أضف الى السلة
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        newestOnTop
        closeOnClick
        rtl
        theme="colored"
      />
    </>
  );
}